module.exports = __webpack_public_path__ + "static/img/2.98dee8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/zh/2.png
// module id = evCA
// module chunks = 0